import favicon from 'assets/images/favicon-v2.ico';

// ==============================|| LOGO（favicon-v2.ico） ||============================== //

export default function LogoMain() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img src={favicon} alt="logo" style={{ height: 35, width: 'auto', objectFit: 'contain' }} />
      {/* 应用名称置于图标后方,并固定为黑色字体 */}
      <span style={{ marginLeft: '10px', fontSize: '18px', fontWeight: 500, color: '#000' }}>灵犀</span>
    </div>
  );
}
